import React, { useState, useEffect } from "react";
import { ChakraProvider } from '@chakra-ui/react';
import './App.css';

import AppRoutes, { UnauthorizedRoutes } from '../Routes';
import { authenticate } from "../APIs";
import { AuthContext } from "../Library/contexts";
import EventEmitter from "../Library/EventEmitter";
import { useLocation } from "react-router-dom";
import { getItemFromLocalStorage } from "../Library/helpers";

function App() {
  const [ isLoading, setIsLoading ] = useState(true);
  const [ authenticated, setAuthenticated ] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (!global.EE) global.EE = new EventEmitter();

    let hostname = window.location.hostname.split(".");
    if (hostname && hostname.length) hostname = hostname[0];

    authenticate((error, data) => {
      setAuthenticated(data);
      setIsLoading(false);

      if (data) {
        if (data.profile) {
          if (data.profile.accessCodes) {
            window.localStorage.setItem("accessCodes", JSON.stringify(data.profile.accessCodes));
          }
          if (data.profile.des) window.localStorage.setItem("des", data.profile.des);
          if (data.profile.user) window.localStorage.setItem("user", true);
          else window.localStorage.removeItem("user");

          if (data.profile.fn) window.localStorage.setItem("fn", data.profile.fn);
          if (data.profile.uh) window.localStorage.setItem("uh", data.profile.uh);

          if (data.profile.rly) window.localStorage.setItem("relay", data.profile.rly);
          else window.localStorage.removeItem("relay");
        } else if (data.assets) {
          if (data.assets.user) window.localStorage.setItem("user", true);
          else window.localStorage.removeItem("user");
        }
        if (getItemFromLocalStorage("theme") && !window.localStorage.getItem("user")) document.body.classList.add("Ev-Light-Theme-Container");
        else document.body.classList.remove("Ev-Light-Theme-Container");
      }
    });
  }, [ location.pathname ]);

  const setProfile = (profile) => {
    setAuthenticated((old) => ({ ...old, profile }));
  };

  if (isLoading) return <div>Loading</div>;

  return (
    <ChakraProvider>
      <AuthContext.Provider value={{ ...authenticated, setProfile }}>
        {authenticated && authenticated.profile ? <AppRoutes codes={authenticated.profile.accessCodes} /> : <UnauthorizedRoutes />}
      </AuthContext.Provider>
    </ChakraProvider>
  );
}

export default App;
